import { render, staticRenderFns } from "./CampaignsDetails.vue?vue&type=template&id=5255eba8&"
import script from "./CampaignsDetails.vue?vue&type=script&lang=js&"
export * from "./CampaignsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports